// src/views/panelMantenimiento/Services/SecurityModeService.js

const KEY = 'security_mode_cache_v1';
const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;

let inFlight = null;

function now() { return Date.now(); }

function safeNoop(err) {
  // evita ESLint no-empty sin spamear consola
  // Si quieres debug, cambia a: console.debug('[SecurityModeService]', err);
  void err;
}

function setCache(enabled, ttlMs = ONE_YEAR_MS) {
  const payload = { enabled: !!enabled, expiresAt: now() + ttlMs };
  try {
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch (e) {
    safeNoop(e);
  }
  return payload;
}

function getCache() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.expiresAt !== 'number') return null;
    if (now() > parsed.expiresAt) return null;

    return { enabled: !!parsed.enabled, expiresAt: parsed.expiresAt };
  } catch (e) {
    safeNoop(e);
    return null;
  }
}

function clearCache() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    safeNoop(e);
  }
}

export const SecurityModeService = {
  getCached() {
    return getCache();
  },

  seedFromLogin(enabled) {
    // llamado cuando login ya te trajo el valor desde backend
    return setCache(!!enabled);
  },

  /**
   * Obtiene el estado.
   * - Si hay cache válido y force=false -> devuelve cache
   * - Si no hay cache (o expiró) -> hace fetch
   * - Si force=true -> siempre hace fetch
   */
  async getStatus({ force = false } = {}) {
    if (!force) {
      const cached = getCache();
      if (cached) return { enabled: cached.enabled, cached: true };
    }

    // dedupe si varias partes llaman al mismo tiempo
    if (inFlight) return inFlight;

    inFlight = (async () => {
      const res = await fetch('/api/security-mode', { credentials: 'include' });
      if (!res.ok) throw new Error('No se pudo obtener el security mode');

      const data = await res.json().catch(() => ({}));
      const enabled = !!data.enabled;

      setCache(enabled);
      return { enabled, cached: false };
    })();

    try {
      return await inFlight;
    } finally {
      inFlight = null;
    }
  },

  /**
   * Actualiza en servidor y refresca cache local 1 año
   */
  async setEnabled(enabled) {
    const res = await fetch('/api/security-mode', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ enabled: !!enabled })
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok || data?.error) throw new Error(data?.error || 'No se pudo actualizar security mode');

    setCache(!!enabled);
    return { ok: true, enabled: !!enabled };
  },

  clearCache
};